import { render, staticRenderFns } from "./UploadDesign.vue?vue&type=template&id=4e9ae742"
import script from "./UploadDesign.vue?vue&type=script&lang=js"
export * from "./UploadDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports